<script>
  export let title = 'You have successfully signed up';
  export let message = 'Thank you for choosing Curbza. We will be in touch soon!';
</script>

<style>
  #sign-up-success .hero {
    margin-bottom: 2vw;
    text-align: center;
  }

  #sign-up-success .hero-icon i {
    font-size: 128px;
    color: var(--success)
  }

  #sign-up-success .title,
  #sign-up-success .lead-paragraph {
    text-align: center;
  }
</style>

<main id="sign-up-success">
  <div class="hero hero-icon">
    <i class="fas fa-check"></i>
  </div>
  <h1 class="title">{@html title}</h1>
  <p class="lead-paragraph">{@html message}</p>
</main>